import { FormattedMessage } from 'react-intl';
import Icon from '../../../../../assets/icons/legacy/microphone.svg';
export const UnmutedMicrophone = () => {
    return (<>
      <Icon />
      <FormattedMessage id="notification.microphone-unmuted{linebreak}" tagName="p" values={{
            linebreak: <br />,
        }}/>
    </>);
};
